module.exports = __webpack_public_path__ + "3c9b6e89df66ea383bb5c464fd9a8abd.svg";